import { gql } from "@apollo/client";

export const GENERATE_REGISTRATION_OPTIONS = gql`
  mutation GenerateRegistrationOptions {
    generateRegistrationOptions {
      challenge
      rp {
        name
      }
      user {
        id
        name
        displayName
      }
      pubKeyCredParams {
        type
        alg
      }
      timeout
      attestation
    }
  }
`;

export const ENROLL_WEBAUTHN = gql`
  mutation EnrollWebauthn($credential: JSON!) {
    enrollWebauthn(credential: $credential) {
      success
      message
      data
    }
  }
`;
